import React, { Fragment } from 'react';
import Layout from '../Layout/Layout';
import PaymentPursesList from '../Payments/PaymentPursesList';
import AlertModal from '../../modals/AlertModal/AlertModal';

const PaymentPursesListWrapper = ({error, theme, modal, closeModal, isMember, className, showAlert, closeAlert, ...rest}) => {
  const renderWrapper = children => <Layout formattedTitle="pages.payment-data.title">{children}</Layout>;
  const renderMemberWrapper = children => <div className={className || ''}>{children}</div>;

  const content = (
    <Fragment>
      <PaymentPursesList theme={theme} isMember={isMember} {...rest} showAlert={showAlert} closeAlert={closeAlert}/>

      {error.message && (
        <AlertModal open={modal} message={error.message} onClose={closeModal} />
      )}
    </Fragment>
  );

  return (!isMember ? renderWrapper(content) : renderMemberWrapper(content));
};

export default PaymentPursesListWrapper;
